import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
function Icon(props) {
    return (
        <a href="#" data-bs-toggle="tooltip" title={`${props.spanText}`}>
      <div className="col-lg-4 col-12 text-left align-middle">
        <svg className={`icon ${props.status} mr-2`}>
          <use xlinkHref={`${iconSprite + "#" + props.icon}`}></use>
        </svg>
      </div></a>
    );
  }

export default Icon;